import React, { ReactNode } from "react";
import LeftLaurel from "@/shared/components/PolicyCalloutTest/assets/left-laurel.svg";
import RightLaurel from "@/shared/components/PolicyCalloutTest/assets/right-laurel.svg";
import Star from "@/shared/components/PolicyCalloutTest/assets/star.svg";
import { cn } from "@/shared/utils";

interface AccoladeProps {
    logoImg: ReactNode;
    text: string | ReactNode;
    showStars?: boolean;
    starsPosition?: "above" | "below";
    logoTextGap?: string;
}

const Stars = () => (
    <div className="flex justify-center gap-1">
        {[...Array(5)].map((_, i) => (
            <Star key={i} className="size-3 text-content-secondary xs:size-4  sm:size-3 md:size-5" />
        ))}
    </div>
);

const Accolade = ({ logoImg, text, showStars = false, starsPosition = "below", logoTextGap = "gap-1" }: AccoladeProps) => {
    const laurelClass = "hidden shrink-0 text-content-inactive sm:flex lg:hidden xl:flex w-6 h-12";

    return (
        <div className="flex max-w-[232px] items-center gap-1">
            {/* Left Laurel */}
            <LeftLaurel className={laurelClass} />

            <div className={cn("flex flex-col items-center", logoTextGap)}>
                {logoImg}

                {/* Text and Stars */}
                <div className="flex flex-col items-center">
                    {/* Stars above text */}
                    {showStars && starsPosition === "above" && <Stars />}

                    {/* Text */}
                    <p className="text-center text-xs font-medium text-content-secondary xs:text-sm md:text-xl lg:text-base">{text}</p>

                    {/* Stars below text */}
                    {showStars && starsPosition === "below" && <Stars />}
                </div>
            </div>

            {/* Right Laurel */}
            <RightLaurel className={laurelClass} />
        </div>
    );
};

export default Accolade;
